"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandedGlobalColors = void 0;
var agco_1 = require("./agco");
var massey_1 = require("./massey");
var valtra_1 = require("./valtra");
var fendt_1 = require("./fendt");
var getBrandedGlobalColors = function (brand) {
    switch (brand) {
        case 'valtra':
            return valtra_1.valtraGlobalColors;
        case 'massey':
            return massey_1.masseyGlobalColors;
        case 'fendt':
            return fendt_1.fendtGlobalColors;
        case 'agco':
        default:
            return agco_1.agcoGlobalColors;
    }
};
exports.getBrandedGlobalColors = getBrandedGlobalColors;
